import { render, staticRenderFns } from "./RowOther.vue?vue&type=template&id=96dad4e0"
import script from "./RowOther.vue?vue&type=script&lang=js"
export * from "./RowOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports